import { useCallback, useContext } from 'react';
import _get from 'lodash/get';
import _isNil from 'lodash/isNil';
import _isNaN from 'lodash/isNaN';
import _isEmpty from 'lodash/isEmpty';
import _find from 'lodash/find';
import { AjaxContext, formatListData, AppContext, EMPTY_ARRAY, UserContext } from 'commons-ui';

import { UserDetailsContext } from 'context/userDetails';
import { ACTION, PAGE_NAMES, USER_PROFILE_RESOURCES } from 'constant';
import { RegistrationFilters } from './constants';

const useService = () => {
	const { app } = useContext(AppContext);
	const { postData } = useContext(AjaxContext);
	const {
		selectedUser: { uid, ludoUserId }
	} = useContext(UserDetailsContext);
	const { permissionsConfig } = useContext(UserContext);
	const getRegisteredTournaments = useCallback(async (filtersData: RegistrationFilters) => {
		const { appName } = app;
		const { tournamentID, registeredFrom, registeredTill, gameName, pwfInviteId, tournamentType } = filtersData;

		let filters = {};
		switch (true) {
			case !_isNil(tournamentID) && !_isNaN(tournamentID):
				filters = { ltid: tournamentID };
				break;
			case !_isNil(tournamentType) && !_isEmpty(tournamentType) && !_isNil(pwfInviteId) && !_isNaN(pwfInviteId):
				filters = { pwfInviteId, gameType: tournamentType };
				break;
			case !_isNil(registeredFrom) && !_isNaN(registeredFrom) && !_isNil(registeredTill) && !_isNaN(registeredTill):
				filters = { registeredFrom, registeredTill, ...(_isEmpty(tournamentType) ? {} : { gameType: tournamentType }) };
				break;
			default:
				break;
		}
		const permission = _find(permissionsConfig, { actionName: ACTION.getRegisteredTournaments });
		const result = await postData({
			endpoint: `/dashboard/getRegisteredTournaments/${PAGE_NAMES.userProfile}-${USER_PROFILE_RESOURCES.gameplay}-getRegisteredTournaments`,
			queryParams: {
				appName
			},
			body: {
				zupeeUserId: uid,
				uid: ludoUserId,
				gameName,
				...(filters || {})
			},
			customHeaders: {
				isMasked: permission?.isMasked || false
			}
		});
		const data = _get(result, ['data', 'data'], []);
		const restructuredData = [...(data[0] || EMPTY_ARRAY), ...(data[1] || EMPTY_ARRAY), ...(data[2] || EMPTY_ARRAY)];

		return { rowCount: restructuredData.length, data: formatListData(restructuredData) };
	}, []);

	return { getRegisteredTournaments };
};

export default useService;
